import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody54';
import FooterNew from '../component/FooterNew';
import { Helmet } from 'react-helmet';

const CaseStudy54 = ({setBlank}) => {
     
    const headings = "<h4>Development Of An Institutional-Grade</h4><h2 style='display:inline-block;color:#ffffff;transform:scale(0.85);transform-origin:left;'>Financial Reporting Template</h2>";

  return (
    <>
        <Helmet>
        <title>Development Of An Institutional-Grade Financial Reporting Template</title>
        <meta property="og:title" content="Development Of An Institutional-Grade Financial Reporting Template" />
        <meta property='og:description' content='Development Of An Institutional-Grade Financial Reporting Template'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy54" headings={headings} />  
        <Casestudybody />
        <FooterNew setBlank={setBlank} />
    </>
  )
}

export default CaseStudy54
